var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},_vm._l((_vm.images),function(item,index){return _c('img',{key:index,staticClass:"item",attrs:{"src":item}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }